import { Skeleton } from '@/components/ui/skeleton';
import { PlatformPicker } from './RunBuildPlatforms';
import { EnvironmentPicker } from './RunBuildEnvironment';
import { RunBuildGitFields, RunBuildMetaFields } from './RunBuildGitFields';
import { RunBuildInputs } from './RunBuildInputs';
import { RunBuildTargetFields } from './RunBuildTargetFields';
import { togglePlatform } from './runBuildModel';
import type { RunBuildFormModel } from './useRunBuildForm';

/** The left column of the sheet: a skeleton while the project, apps and profiles load, then every field. */
export function RunBuildFormBody({ form }: { form: RunBuildFormModel }) {
  return (
    <div className="flex flex-col gap-5 p-4 sm:p-5">
      {form.target.loadingBasics ? <FormSkeleton /> : <FormFields form={form} />}
    </div>
  );
}

function FormSkeleton() {
  return (
    <div className="flex flex-col gap-4" aria-busy="true">
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-11 w-full" />
    </div>
  );
}

function FormFields({ form }: { form: RunBuildFormModel }) {
  const { target, fields } = form;
  return (
    <>
      <RunBuildTargetFields form={form} />
      <EnvironmentPicker environments={target.environments} env={target.env} error={form.errorFor('environment')} onPick={fields.set.setEnvironment} />
      <PlatformPicker
        available={target.availablePlatforms}
        selected={target.selectedPlatforms}
        profileSlug={target.group?.slug}
        error={form.errorFor('platforms')}
        onToggle={(pl) => fields.set.setPlatforms(togglePlatform(target.selectedPlatforms, pl))}
      />
      <RunBuildGitFields form={form} />
      <RunBuildInputs form={form} />
      <RunBuildMetaFields form={form} />
    </>
  );
}
